<template>
  <div class="cus-path__div" :style="edgeStyle"></div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
const props = defineProps({
  points: {
    type: Array,
    default: () => []
  },
  nodeWidth: {
    type: Number,
    default: 100
  },
  nodeHeight: {
    type: Number,
    default: 100
  }
})

const edgeStyle = ref(null)
onMounted(() => {
  edgeStyle.value = getEdgeStyle();
})

function getEdgeStyle() {
  const pointArrLen = props.points.length;
  if (pointArrLen < 2) return;

  const sp = props.points[0];
  const ep = props.points[pointArrLen - 1];
  const borderStyle = '2px solid #788196';
  // 横线
  if (sp.y == ep.y) {
    return {
      width: (ep.x > sp.x) ? (ep.x - sp.x) + 'px' : (sp.x - ep.x) + 'px',
      height: '1px',
      left: (ep.x > sp.x) ? (sp.x + (props.nodeWidth / 2)) + 'px' : (ep.x + (props.nodeWidth / 2)) + 'px',
      top: sp.y + (props.nodeHeight/ 2)  + 'px',
      'border-top': borderStyle,
    }
  }

  // 纵线
  if (sp.x == ep.x) {
    return {
      width: '1px',
      height: (ep.y > sp.y) ? (ep.y - sp.y) + 'px' : (sp.y - ep.y) + 'px',
      left: sp.x + (props.nodeWidth / 2)  + 'px',
      top: (ep.y > sp.y) ? (sp.y + (props.nodeHeight/ 2)) + 'px' : (ep.y + (props.nodeHeight/ 2)) + 'px',
      'border-left': borderStyle,
    }
  }

  /** 矩形的边 */
  // sp:左上角 ep:右下角
  if (sp.x < ep.x && sp.y < ep.y) {
    // 默认从sp到ep >>> 上边+右边
    const defaultStyle = {
      width: (ep.x - sp.x) + 'px',
      height: (ep.y - sp.y) + 'px',
      left: (sp.x + (props.nodeWidth / 2)) + 'px',
      top: sp.y + (props.nodeHeight/ 2)  + 'px',
      'border-top': borderStyle,
      'border-right': borderStyle,
      'border-top-right-radius': '3px'
    }
    return defaultStyle;
  }
  // ep:左上角 sp:右下角
  if (sp.x > ep.x && sp.y > ep.y) {
    // 默认从sp到ep >>> 右边+上边
    const defaultStyle = {
      width: (sp.x - ep.x) + 'px',
      height: (sp.y - ep.y) + 'px',
      left: (ep.x + (props.nodeWidth / 2)) + 'px',
      top: ep.y + (props.nodeHeight/ 2)  + 'px',
      'border-top': borderStyle,
      'border-right': borderStyle,
      'border-top-right-radius': '3px'
    }
    return defaultStyle;
  }

  // sp:右上角 ep:左下角
  if (sp.x > ep.x && sp.y < ep.y) {
    // 默认从sp到ep >>> 上边+左边
    const defaultStyle = {
      width: (sp.x - ep.x) + 'px',
      height: (ep.y - sp.y) + 'px',
      left: (ep.x + (props.nodeWidth / 2)) + 'px',
      top: sp.y + (props.nodeHeight/ 2)  + 'px',
      'border-top': borderStyle,
      'border-left': borderStyle,
      'border-bottom-left-radius': '3px'
    }
    return defaultStyle;
  }

  // ep:右上角 sp:左下角
  if (sp.x > ep.x && sp.y < ep.y) {
    // 默认从sp到ep >>> 左边+上边
    const defaultStyle = {
      width: (ep.x - sp.x) + 'px',
      height: (sp.y - ep.y) + 'px',
      left: (sp.x + (props.nodeWidth / 2)) + 'px',
      top: ep.y + (props.nodeHeight/ 2)  + 'px',
      'border-top': borderStyle,
      'border-left': borderStyle,
      'border-top-left-radius': '3px'
    }
    return defaultStyle;
  }

}


</script>
<style lang='scss' scoped>
.cus-path__div {
  position: absolute;
  z-index: 1;
  background: transparent;
}
</style>
